import React from "react";
import { useNavigate } from "react-router-dom";
import * as ROUTES from "../../../../utils/routes";

const HubspotHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="hubspot-header">
      <div className="hubspot-header-left">
        <button
          className="back-button"
          onClick={() => navigate(ROUTES.INTEGRATIONS)}
        >
          <svg
            width="4.2"
            height="7.47"
            viewBox="0 0 5 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 1L1 4L4 7"
              stroke="#6A8991"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <span
          className="breadcrumb"
          onClick={() => navigate(ROUTES.INTEGRATIONS)}
          style={{ cursor: "pointer" }}
        >
          All Integrations
        </span>
        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-current">HubSpot</span>
      </div>
    </div>
  );
};

export default HubspotHeader;
